import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { IJobBoard, IJobBoardSharedUser } from 'wisestep-api';
import { WsDataTable, IUserDTO } from 'wisestep-base';

import { useUserContext } from '../../../../../context/UserContext';

type PropTypes = {
  value: string;
  selectedAccount: IJobBoard[];
  usedCount?: number;
};

const SharedUserLists = ({ selectedAccount, usedCount }: PropTypes) => {
  const loggedInUser = useUserContext().userDTO as IUserDTO;
  const selectedAccountDetails: IJobBoard[] = selectedAccount;

  const data = useMemo(() => {
    const selectedAccount = selectedAccountDetails[0];
    if (!selectedAccount || !selectedAccount.jobBoardSharedUsers) {
      return [];
    }

    const jobBoardSharedUsers = [...selectedAccount.jobBoardSharedUsers];
    let loggedInUserIndex = -1;

    const jobBoardSharedUsersData = jobBoardSharedUsers
      .filter((account) => account.email === loggedInUser.email)
      .map((account: IJobBoardSharedUser, index) => {
        if (account.email === loggedInUser.email) {
          loggedInUserIndex = index;
        }
        return {
          accountName: account.email,
          maxPostingCount: `Total Credits : ${account.maxPostingsPerMonth}`,
          usedCount: `Used Credits : ${usedCount}`,
          index: index,
        };
      });

    if (loggedInUserIndex !== -1) {
      const loggedInUserData = jobBoardSharedUsersData.splice(loggedInUserIndex, 1)[0];
      jobBoardSharedUsersData.unshift(loggedInUserData);
    }

    return jobBoardSharedUsersData;
  }, [selectedAccountDetails, loggedInUser.email, usedCount]);

  const columns = [
    {
      Header: 'Account Name',
      accessor: 'accountName',
    },
    {
      Header: 'Shared with',
      accessor: 'maxPostingCount',
    },
    {
      Header: 'Used Count',
      accessor: 'usedCount',
    },
  ];

  return (
    <Grid container item xs={12} pt={3}>
      <WsDataTable
        columns={columns}
        data={data ?? []}
        selectable={false}
        boldItems={['accountName', 'maxPostingCount', 'usedCount']}
        dense={false}
        headless={true}
        pageable={true}
      />
    </Grid>
  );
};
export default SharedUserLists;
